<template>
    <div class="wizard-nav-btns" :class="{'wizard-nav-btns--no-mt': noMt}">
        <button @click="prev" class="btn btn--round wizard-nav-btn">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 21" class="btn__icon">
                <path d="M12.618 2.5a1.5 1.5 0 10-2.236-2l2.236 2zM3 11l-1.118-1-.973 1.088 1.061 1.003L3 11zm7.97 9.59a1.5 1.5 0 102.06-2.18l-2.06 2.18zM10.382.5l-8.5 9.5 2.236 2 8.5-9.5-2.236-2zM1.97 12.09l9 8.5 2.06-2.18-9-8.5-2.06 2.18z"/>
            </svg>
        </button>
        <button @click="next" class="btn wizard-nav-btn">{{ text ? text : 'Další otázka' }}
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 21" class="btn__icon">
                <path d="M1.382 18.5a1.5 1.5 0 002.236 2l-2.236-2zM11 10l1.118 1 .973-1.088-1.061-1.003L11 10zM3.03.41A1.5 1.5 0 00.97 2.59L3.03.41zm.588 20.09l8.5-9.5-2.236-2-8.5 9.5 2.236 2zM12.03 8.91l-9-8.5L.97 2.59l9 8.5 2.06-2.18z" fill="#fff"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: "GroheNavBtns",
    props: {
        next: {
            type: Function,
            required: true
        },
        prev: {
            type: Function,
            required: true
        },
        text: {
            type: String
        },
        noMt: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>
